import React, { useContext, useEffect, useMemo, useState } from "react";
import { NavigationContext } from "../../../context/navigation-context";
import fetchHook from "../../../hooks/fetchMSSQL-hook";
import moment from "moment";
import "moment/locale/pl";
import NoResults from "../../../components/NoResults/NoResults";
import { NotificationManager } from "react-notifications";
import SearchFilter from "../../../components/Filter/SearchFilter";

export default function PrepaidsTransactionns() {
    const { setHeaderData } = useContext(NavigationContext);
    const { fetchMssqlApi } = fetchHook();
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [prepaidTransactions, setPrepaidTransactions] = useState([]);
    const reportList = [
        { reportId: 86, reportColor: "primary" },
        { reportId: 87, reportColor: "danger" },
        { reportId: 88, reportColor: "success" },
    ];


    const defaultFilter = {
        page: 1,
        sortBy: "none",
        dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        prepaidId: null,
        ownerData: "",
        printedCodeName: "",
        codeName: "",
        prepaidGroupId: null,
        prepaidGroupName: "",
        terminalId: null,
        terminalSerialNo: "",
        machineId: null,
        machineName: "",
        machineFeederNo: "",
    };

    const [filter, setFilter] = useState(defaultFilter);
    const [settingsFilter, setSettingsFilter] = useState({
        saveFilters: true,
        autoLoading: true,
        additionalFilter: true,
        flatView: false,
        rowsPerPage: 50,
    });

    useEffect(() => {
        setHeaderData({ text: "Transakcje prepaid" });
    }, [setHeaderData]);

    const rowsPerPage = Number(settingsFilter?.rowsPerPage) || 50;

    const search = (f, pageSize, page) => {
        const currentFilter = f || filter;

        const p = Math.max(1, Number(page ?? currentFilter?.page) || 1);
        const rpp = Number(pageSize ?? settingsFilter?.rowsPerPage ?? rowsPerPage) || 50;

        setFilter((prev) => ({ ...prev, ...currentFilter, page: p }));
        setSettingsFilter((prev) => ({ ...prev, rowsPerPage: rpp }));

        const start = currentFilter?.dateTimeRangeFrom;
        const end = currentFilter?.dateTimeRangeTo;

        if (!moment(start).isValid() || !moment(end).isValid()) {
        NotificationManager.error("Wprowadź poprawną datę");
        return;
        }

        const body = {
        StartDateTime: moment(start).format("YYYY-MM-DD HH:mm:ss.SSS"),
        EndDateTime: moment(end).format("YYYY-MM-DD HH:mm:ss.SSS"),

        TerminalId: currentFilter?.terminalId ?? null,
        MachineId: currentFilter?.machineId ?? null,

        PrepaidId: currentFilter?.prepaidId ?? null,
        PrepaidGroupId: currentFilter?.prepaidGroupId ?? null,

        PrepaidStatusId: currentFilter?.prepaidStatusId ?? null,

        ProductNo:
            String(currentFilter?.machineFeederNo ?? "").trim() !== ""
            ? Number(currentFilter.machineFeederNo)
            : null,
        };

        fetchMssqlApi(
        "prepaid-trxs",
        { method: "POST", data: body, hideNotification: true },
        (res) => setPrepaidTransactions(Array.isArray(res) ? res : [])
        );
    };

    const visibleTransactions = useMemo(() => {
        const p = Math.max(1, Number(filter?.page) || 1);
        const from = (p - 1) * rowsPerPage;
        return (prepaidTransactions || []).slice(from, from + rowsPerPage);
    }, [prepaidTransactions, filter?.page, rowsPerPage]);

    const statusBadge = (trx) => {
        const raw =
        trx?.PrepaidStatus ??
        trx?.Status ??
        trx?.StatusName ??
        trx?.PrepaidStatusName ??
        "";

        const s = String(raw).toLowerCase();

        if (s.includes("zwrot") || s.includes("return")) return "danger";
        if (s.includes("odmow") || s.includes("denied") || s.includes("refus"))
        return "warning";

        if (Number(trx?.Price || 0) <= 0) return "danger";
        return "success";
    };

    const formatOwner = (v) => {
        const t = String(v ?? "");
        if (t.length <= 30) return t;
        return `${t.substring(0, 30)}...`;
    };

    return (
        <>
        <SearchFilter
            filterName="prepaidTrxs"
            defaultFilter={defaultFilter}
            reportList={reportList}
            onFilterChange={setFilter}
            onSettingsChange={setSettingsFilter}
            search={search}
            totalCount={prepaidTransactions.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).length}
            forNow
        />

        <div className="card-body pt-0">
            {prepaidTransactions?.length ? (
                <div
                    className="overflow-auto custom-scroll"
                    style={{
                    maxHeight: `${windowHeight - 220}px`,
                    overflowY: 'auto',
                    }}
                >
            <table className="table table-striped border">
                <thead>
                <tr className="headers-color pe-none">
                    <th className="text-center align-middle">
                    Właściciel karty prepaid
                    </th>
                    <th className="text-center align-middle">Terminal</th>
                    <th className="text-center align-middle">Automat</th>
                    <th className="text-center align-middle">Data / czas</th>
                    <th className="text-center align-middle" style={{ gap: "5px" }}>
                    Cena / Nr wyboru / Status <br />
                    <span className="badge badge-success">Pozytywna</span>
                    <span className="badge badge-danger ml-1">Zwrot</span>
                    <span className="badge badge-warning ml-1">Odmowa</span>
                    </th>
                    <th className="text-center align-middle">Karta prepaid</th>
                </tr>
                </thead>

                <tbody>
                {visibleTransactions.map((trx, idx) => {
                    const productNo = trx?.ProductNo ?? trx?.MachineFeederNo ?? "";
                    const price = Number(trx?.Price || 0);

                    return (
                    <tr key={idx}>
                        <td className="text-center">{formatOwner(trx?.OwnerData)}</td>
                        <td className="text-center">{trx?.Terminal ?? ""}</td>
                        <td className="text-center">{trx?.MachineFullName ?? ""}</td>
                        <td className="text-center">{trx?.CreateDateTime ?? ""}</td>

                        <td className="text-center">
                        <div className="d-flex justify-content-center">
                            <h6 className="m-0">
                            <span className={`badge badge-${statusBadge(trx)}`}>
                                {`${Intl.NumberFormat("pl-PL", {
                                style: "currency",
                                currency: "PLN",
                                }).format(price)}${productNo !== "" ? ` (${productNo})` : ""}`}
                                {trx?.PrepaidStatus ? ` • ${trx.PrepaidStatus}` : ""}
                            </span>
                            </h6>
                        </div>
                        </td>

                        <td className="text-center">
                        {`${trx?.PrintedCode ?? ""}${trx?.Code ? ` (${trx.Code})` : ""}`}
                        </td>
                    </tr>
                    );
                })}
                </tbody>
            </table>
            </div>
            ) : (
            <NoResults />
            )}
        </div>
        </>
    );
    }
